module.exports = __webpack_public_path__ + "static/media/no_image.6ff75956.jpg";